'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FeatherInfo, FeatherMapPin } from '@subframe/core';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
import { enderecoEmLinha } from '@/shared/utils/enderecoAr';
import type { EnderecoAr } from '@/types/arbitral/envioArTypes';
interface CorrigirEnderecoArDialogProps {
  aberto: boolean;
  endereco: EnderecoAr;
  onFechar: () => void;
  onDevolver: (observacao: string) => void;
}
export function CorrigirEnderecoArDialog(t0) {
  const $ = _c(37);
  const {
    aberto,
    endereco,
    onFechar,
    onDevolver
  } = t0;
  const [observacao, setObservacao] = useState("");
  let t1;
  if ($[0] !== observacao) {
    t1 = observacao.trim();
    $[0] = observacao;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const podeDevolver = t1 !== "";
  let t2;
  if ($[2] !== onFechar) {
    t2 = () => {
      setObservacao("");
      onFechar();
    };
    $[2] = onFechar;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleFechar = t2;
  let t3;
  if ($[4] !== observacao || $[5] !== onDevolver || $[6] !== podeDevolver) {
    t3 = () => {
      if (!podeDevolver) {
        return;
      }
      onDevolver(observacao);
      setObservacao("");
    };
    $[4] = observacao;
    $[5] = onDevolver;
    $[6] = podeDevolver;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleDevolver = t3;
  let t4;
  if ($[8] !== handleFechar) {
    t4 = open => !open && handleFechar();
    $[8] = handleFechar;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-1"><span className="text-heading-3 font-heading-3 text-default-font">Este endereço está errado</span><span className="text-caption font-caption text-subtext-color">A secretaria vai revisar e enviar uma nova solicitação. Conte o que está errado para ela não repetir o mesmo endereço.</span></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherMapPin className="mt-0.5 h-4 w-4 shrink-0 text-neutral-500" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-caption-bold font-caption-bold text-subtext-color">Endereço informado</span>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== endereco) {
    t8 = enderecoEmLinha(endereco);
    $[13] = endereco;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className="flex items-start gap-2 rounded-[8px] border border-solid border-neutral-200 px-3 py-2">{t6}<div className="flex flex-col">{t7}<span className="text-body font-body text-default-font">{t8}</span></div></div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = evento => setObservacao(evento.target.value);
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== observacao) {
    t11 = <TextArea label={"O que est\xE1 errado"} helpText={"Sem essa informa\xE7\xE3o a secretaria n\xE3o sabe o que corrigir."} className="w-full"><TextArea.Input value={observacao} onChange={t10} placeholder={"Ex.: a empresa mudou de endere\xE7o em janeiro; o n\xFAmero correto \xE9 1200."} rows={4} /></TextArea>;
    $[18] = observacao;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="bg-warning-50 flex items-start gap-2 rounded-[8px] px-3 py-2"><FeatherInfo className="text-warning-600 mt-0.5 h-3.5 w-3.5 shrink-0" /><span className="text-caption font-caption text-warning-800">A cobrança atual é cancelada e nada é pago. Você não perde o pedido: ele volta para a secretaria corrigir.</span></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== handleFechar) {
    t13 = <Button variant="neutral-secondary" onClick={handleFechar}>Cancelar</Button>;
    $[21] = handleFechar;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = !podeDevolver;
  let t15;
  if ($[23] !== handleDevolver || $[24] !== t14) {
    t15 = <Button variant="brand-primary" disabled={t14} onClick={handleDevolver}>Devolver para correção</Button>;
    $[23] = handleDevolver;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = <div className="flex w-full items-center justify-end gap-3">{t13}{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t11 || $[30] !== t16 || $[31] !== t9) {
    t17 = <Dialog.Content className="w-full max-w-[520px] gap-5 rounded-[16px] p-6">{t5}{t9}{t11}{t12}{t16}</Dialog.Content>;
    $[29] = t11;
    $[30] = t16;
    $[31] = t9;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== aberto || $[34] !== t17 || $[35] !== t4) {
    t18 = <Dialog open={aberto} onOpenChange={t4}>{t17}</Dialog>;
    $[33] = aberto;
    $[34] = t17;
    $[35] = t4;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
}